<div class="text-center  instructionheading mt-4">
  <h4>
    Instructions for Submitting Your Consumer Claim Form<br/>
    for the Sandoz and Sun/Taro Settlements
  </h4>
</div>
<br />
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row">
    <div class="col-md-12">
      If you are a CONSUMER and you are a member of the End-Payer Plaintiffs’ (EPP) Sandoz Settlement Class and/or the EPP Sun/Taro Settlement Class,
      you are entitled to file a claim for a share of the settlement funds. (See Section C of the Claim Form below for further information on
      eligibility.)<br /><br />

      To file a claim, you must complete and submit a claim form by using one of the two methods below. Your claim form must be submitted online,
      or mailed and postmarked, no later than <b>November 9, 2026</b>. Any late submissions will not receive any payment from the Settlements.<br /><br />

      Method 1: <u>Submit Your Claim Online</u><br /><br />


      Follow the prompts on the next page to complete the
      form, upload any supporting document(s), electronically sign the form, and submit it online. When you sign and submit the claim form online,
      you are swearing under penalty of perjury that you qualify to submit a claim based on the eligibility criteria stated in the online form.
      (A copy of the criteria is in <i>Section C</i> of the claim form.) Your electronic signature and form submission will meet the
      requirements of the Electronic Signatures Act, 15 U.S.C. § 7001, et seq., and will have the same force and effect as if you signed the
      claim form in hard copy. Once your claim form is submitted, a confirmation screen will appear that you can save for your records. If you
      use this method, you must submit your claim form no later than <b>November 9, 2026</b>.<br />


      <p style="text-align:center; font-weight:bold; text-decoration:underline">OR</p><br />

      Method 2: <u>Submit Your Claim Via U.S. Mail</u><br /><br />

      Instead of submitting your form online, you may complete and submit a paper version of the claim form Click <a href="../../../assets/Docs/2026/EPP Consumer Claim Form.pdf" target="_blank">HERE</a> to download a printable
      version of the claim form and instructions on how to complete and submit a paper form, or call 1-877-316-0171 to ask the Claims
      Administrator to mail you a paper version of the claim form and instructions.<br /><br />

      If you use this method, you must mail your claim so that it is <u>postmarked</u> no later than <b>November 9, 2026</b>.<br /><br />

      Submitting a claim form does not guarantee that you will receive a payment from the Settlements. If the Claims Administrator rejects or reduces your claim,
      you will be notified, and you may follow the dispute resolution process described in Section E of the claim form.<br /><br /><br/><br/>

      <b>TO FIND OUT IF A DRUG YOU PURCHASED IS INCLUDED IN THE SETTLEMENTS</b><br/><br/>

      Review the list of drugs included in the settlement <a href="../../../assets/Docs/2026/Drug List for Claim Form (2026-07-30).pdf" target="_blank">HERE</a><br/><br/>

      Or<br/><br/>

      Use the Drug Lookup Tool below

             <div class="container">
               NDC List v3
               <div class="containerLogin login-container">
                 <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">

                   <div class="col-md-12 login-form-1">
                     <h3 class="misc-titles text-center">Drug Search Tool</h3>
                     <div class="container" style="border:1px solid #bebaba">
                       <br /><br />
                       <div class="form-group">
                         <div class="row">
                           <div class="col-md-12">
                             <label for="drugName" style="font-weight:bold">Enter Drug Name: <span style="color:red" class="required"> *</span></label>
                             <input type="text" class="form-control" formControlName="drugName" trim="blur" autocomplete="off"
                                    [ngClass]="{ 'is-invalid': submitted && f.drugName.errors }" [(ngModel)]="inputValue" />
                             <div *ngIf="submitted && f.drugName.errors" class="invalid-feedback">
                               <div *ngIf="f.drugName.errors.required">This field is required</div>
                               <div *ngIf="f.drugName.errors.minlength">This field must be at least 8 characters</div>
                               <div *ngIf="f.drugName.errors.maxlength">
                                 This field must not be greater than 8 characters
                               </div>
                               <div *ngIf="f.drugName.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                             </div>
                           </div>
                         </div>
                       </div>
                       <br /><br />
                       <div class="row">
                         <div class="col-md-12 text-center">
                           <div class="form-group">
                             <button class="btn btn-primary" id="login" [disabled]="clicked">Search</button>
                           </div>
                         </div>
                       </div>
                       <div class="row mt-3" *ngIf="showDivInClass == true">
                         <div class="col-md-12 text-center" style="font-weight:bold; color:green; font-size:2.0em">
                           <b>Drug "{{ submittedValue }}" was Found</b><br /><br />

                           This drug is included in the Settlement and may be eligible under the class action. Please review the applicable criteria and submit a claim if you believe you qualify.
                         </div>
                       </div>
                       <div class="row mt-3" *ngIf="showDivNotInClass == true">
                         <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
                           <b>Drug "{{ submittedValue }}" was Not Found</b><br /><br />

                           This drug  does not appear on the list of products currently included in the Settlement. If you believe this result is incorrect, please review the complete list of drugs using the link provided above or contact the Settlement Administrator for assistance.
                         </div>
                       </div>
                       <br />
                       <br />
                     </div>
                     <br />
                   </div>


                 </form>
                 <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                              size="medium"
                              color="#fff"
                              type="ball-scale-multiple">
                   <p style="font-size: 20px; color: white">Loading...</p>
                 </ngx-spinner>
               </div>
             </div>

      <div class="row">
        <div class="col-md-12" style="font-weight:bold; text-align:center">
          To file a <u>Consumer</u> Claim online, click the "Next" button below. 
        </div>
      </div>
      <ul class="list-inline text-center mt-4">
        <li class="list-inline-item">
          <button class="btn btn-primary" [routerLink]='["/consumer-claimants"]' type="button">Next</button>
        </li>
      </ul>

    </div>
  </div>
</div>


























